// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { QuickWinType } from "../schema";

export function serialize_QuickWinType_internal(value: QuickWinType): unknown {
  return ((value: "INSIGHT" | "REFLECTION"): unknown => {
    return value;
  })(value);
}
export function serialize_QuickWinType(obj: QuickWinType): string {
  return renderJsonWithNumbersAsBigint(serialize_QuickWinType_internal(obj));
}
export function deserialize_QuickWinType_internal(value: unknown): ParserResult<QuickWinType> {
  return ((value: unknown): ParserResult<"INSIGHT" | "REFLECTION"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/QuickWinType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "INSIGHT":
        return { success: true, value: "INSIGHT" };
      case "REFLECTION":
        return { success: true, value: "REFLECTION" };
      default:
        return { success: false, reason: `[#/components/schemas/QuickWinType]: '${value}' expected to be enum, one of 'INSIGHT, REFLECTION'.` };
    }
  })(value);
}
export function deserialize_QuickWinType(str: string): ParserResult<QuickWinType> {
  return deserialize_QuickWinType_internal(parseJsonWithNumbersAsBigint(str));
}
